import { createFileRoute } from "@tanstack/react-router"
import { Pricing, meta } from "@/content"

export const Route = createFileRoute("/(public)/pricing")({
  component: RouteComponent,
  head: () => ({ meta: meta({ title: "Pricing" }) }),
})

function RouteComponent() {
  return <Pricing />
}
